import { ModernBlocksBaseClassNames } from '../../modernBlocks.state'

type JotformBlockClassNames = ModernBlocksBaseClassNames &
  Partial<{
    // INSERT BLOCK SPECIFIC CLASSNAMES HERE!
  }>

export const jotformBlockClasses: JotformBlockClassNames = {
  // DEFAULTS
  block: 'block block--jotform',
  inview: 'inview',
  inner: 'block__inner ls-gutter ls-spacing--s',
  header: 'block__header ls-container--nogut',
  label: 'block__label text--s',
  title: 'block__title title--m',
  intro: 'block__intro text--l',
  content: 'block__content ls-container--l-nogut',

  // BLOCK SPECIFIC
}
